import React from 'react'
import TextColorsButton from './TextColorsButton'

const COLORS = {
  Green: '#00a88f',
  Orange: '#f7931d',
  Pink: '#ec098c',
  Blue: '#007091',
  Gray: '#77787B'
}

const hasTextColors = state => state.marks.count() &&
  state.marks.some(mark => mark.type in COLORS)

const hasTextColor = (state, color) => {
  return state.marks.count() &&
    state.marks.some(mark => mark.type === color)
}

const marks = {}

for (let key in COLORS) {
  let color = COLORS[key]
  marks[key] = ({attributes, children}) => <span {...attributes} style={{color}}>{children}</span> // eslint-disable-line
}

const TextColorsSchema = {
  marks
}

const onClickButton = (e, state, color) => {
  e.preventDefault()
  return onApply(state, color)
}

const onApply = (state, color) => {
  let transform = state
    .transform()

  for (let key in COLORS) {
    if (key !== color && hasTextColor(state, key)) {
      transform.removeMark(key)
    }
  }

  return transform
    .toggleMark(color)
    .focus()
    .apply()
}

const TextColorsPlugin = options => {
  return {
    schema: TextColorsSchema
  }
}

export {
  COLORS,
  hasTextColor,
  hasTextColors,
  onClickButton,
  TextColorsPlugin,
  TextColorsSchema,
  TextColorsButton
}



// WEBPACK FOOTER //
// ./src/components/TextColorsSlatePlugin/TextColorsSlatePluginContainer.js